import axios from "axios";
import { getAuthToken, logout } from "@/lib/auth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (err?.response?.status === 401 && !String(err?.config?.url || "").includes("/login")) {
      await logout();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const api = {
  stats: () => client.get("/stats").then((r) => r.data),
  listAccounts: () => client.get("/accounts").then((r) => r.data),
  accountGroups: () => client.get("/account-groups").then((r) => r.data),
  addAccount: (data) => client.post("/accounts", data).then((r) => r.data),
  uploadAccount: (formData) =>
    client.post("/accounts/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  deleteAccount: (id) => client.delete(`/accounts/${id}`).then((r) => r.data),
  checkAccounts: () => client.post("/accounts/check", null, { timeout: 300000 }).then((r) => r.data),
  deleteInactiveAccounts: () => client.delete("/accounts/inactive").then((r) => r.data),
  getGroups: (id) => client.get(`/accounts/${id}/groups`).then((r) => r.data),
  sessionTest: (data) => client.post("/session-test", data).then((r) => r.data),
  upload: (formData) =>
    client.post("/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  listCampaigns: () => client.get("/campaigns").then((r) => r.data),
  createCampaign: (data) => client.post("/campaigns", data).then((r) => r.data),
  updateCampaign: (id, data) => client.put(`/campaigns/${id}`, data).then((r) => r.data),
  startCampaign: (id) => client.post(`/campaigns/${id}/start`).then((r) => r.data),
  stopCampaign: (id) => client.post(`/campaigns/${id}/stop`).then((r) => r.data),
  deleteCampaign: (id) => client.delete(`/campaigns/${id}`).then((r) => r.data),
  deleteCampaignAccounts: (id) => client.delete(`/campaigns/${id}/accounts`).then((r) => r.data),
  campaignTargets: (id) => client.get(`/campaigns/${id}/targets-health`).then((r) => r.data),
  removeGroups: (id, group_ids) => client.post(`/campaigns/${id}/remove-groups`, { group_ids }).then((r) => r.data),
  logs: () => client.get("/logs").then((r) => r.data),
  clearLogs: () => client.delete("/logs").then((r) => r.data),
  listProxies: () => client.get("/proxies").then((r) => r.data),
  loadProxies: (data) => client.post("/proxies", data).then((r) => r.data),
  clearProxies: () => client.delete("/proxies").then((r) => r.data),
  deleteProxy: (id) => client.delete(`/proxies/${id}`).then((r) => r.data),
  testProxy: (data) => client.post("/proxies/test", data).then((r) => r.data),
  testStoredProxy: (id) => client.post(`/proxies/${id}/test`).then((r) => r.data),
  assignProxies: (data) => client.post("/proxies/assign", data).then((r) => r.data),
  unassignProxies: (data) => client.post("/proxies/unassign", data).then((r) => r.data),
  proxyCoverage: () => client.get("/proxies/coverage").then((r) => r.data),
};
